import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Stack, useTheme } from "@mui/material";
import { MuiMarkdown_V2 } from "../Shared/components/MuiMarkdown/MuiMarkdown_V2";
/**
 * Displays subtext in a box using primary color for the border
 * @param text
 * @returns
 */
export const SubText = ({ text }) => {
    const theme = useTheme();
    return (_jsx(Stack, Object.assign({ justifyContent: "center", alignItems: "center" }, { children: _jsx(Box, Object.assign({ p: 2, border: `2px solid ${theme.palette.primary.main}`, borderRadius: 5, width: "75%" }, { children: _jsx(MuiMarkdown_V2, { children: text }) })) })));
};
